import LineUpGroup from "./lineup-group.type";

export class GroupStatistics {

  details: LineUpGroup;
  maxMembers: number;
  currentMembers: number;

}
